import { GizmoHelper, GizmoViewport } from "@react-three/drei";
import { useRoomStore } from "../../store";

function FixedElements({ isEditing }) {
  const lightIntensity = useRoomStore((s) => s.lightIntensity);

  // Base intensities multiplied by the user's light intensity setting
  const ambientIntensity = 1 * lightIntensity;
  const directionalIntensity = 2 * lightIntensity;

  return (
    <>
      <ambientLight intensity={ambientIntensity} />
      <directionalLight intensity={directionalIntensity} position={[0, 4, 8]} />
      {/* <Environment preset="warehouse" /> */}
      {isEditing && false && (
        <GizmoHelper
          alignment="bottom-right"
          renderPriority={2}
          margin={[80, 80]}
        >
          <GizmoViewport
            axisColors={["red", "green", "blue"]}
            labelColor="white"
          />
        </GizmoHelper>
      )}
    </>
  );
}

export default FixedElements;
